/** Figma `Textarea`(Components, 31:685)의 축 */
export type TextareaTone = 'default' | 'plain' | 'soft' | 'green';
export type TextareaStatus = 'default' | 'init';

/** 여백 · 글자 · 모서리 */
export const TONE_CLASS: Record<TextareaTone, string> = {
  default: 'rounded-md p-4 typo-body',
  plain: 'rounded-md p-0 typo-body',
  soft: 'rounded-md p-2-5 typo-caption',
  green: 'rounded-md p-2-5 typo-body-sm',
};

/** state=default (+ focus 는 CSS `focus:`) */
export const DEFAULT_STATE_CLASS: Record<TextareaTone, string> = {
  default:
    'border border-border-input bg-bg-surface focus:border-2 focus:border-border-input-focus',
  plain: 'border-0 bg-transparent focus:border-2 focus:border-border-input-focus',
  soft: 'border-0 bg-bg-primary-subtle focus:border-2 focus:border-border-input-focus',
  green: 'border-0 bg-bg-memo focus:border-2 focus:border-border-input-focus',
};

/** state=error (`invalid`) */
export const INVALID_STATE_CLASS: Record<TextareaTone, string> = {
  default: 'border-2 border-border-danger bg-bg-surface',
  plain: 'border-2 border-border-danger bg-transparent',
  soft: 'border-2 border-border-danger bg-bg-primary-subtle',
  green: 'border-2 border-border-danger bg-bg-memo',
};

/** state=disabled */
export const DISABLED_STATE_CLASS: Record<TextareaTone, string> = {
  default: 'border border-border-default bg-bg-disabled',
  plain: 'border-0 bg-transparent',
  soft: 'border-0 bg-bg-muted',
  green: 'border-0 bg-bg-muted',
};
